import { useState } from "react";
import { isCartValid } from "../../../utility/Cookies";
import BasketBoxComponent from "./BasketBoxComponent";
import { Link } from "react-router-dom";
import { SHOPPINGCART_URL_LOCAL } from "../../../utility/BaseUrl";

const DropdownBasketComponent = ({ setData, cart }) => {
  if (cart.items)
    return (
      <>
        <div className="dropdown">
          <a
            className="top-menu-basket-button dropdown-toggle btn1 btn-primary1"
            data-toggle="dropdown"
            href="#"
            id="basket-widget"
            role="button"
            aria-expanded="false"
            aria-haspopup="true"
          >
            <i className="fa fa-shopping-cart ml-half" />{" "}
            <span className="d-none d-lg-inline-block">سبد خرید</span>{" "}
            {cart.items.length > 0 ? (
              <span className="badges">{cart.items.length}</span>
            ) : null}
          </a>
          <div
            className="top-menu-basket-items dropdown-menu"
            aria-labelledby="basket-widget"
            style={{ borderRadius: 15 }}
          >
            {cart.items && cart.items.length > 0 ? (
              <>
                {cart.items.map((item) => {
                  return <BasketBoxComponent setData={setData} item={item} />;
                })}
                <div className="top-menu-basket-container">
                  <Link
                    to={SHOPPINGCART_URL_LOCAL}
                    className="btn btn-block btn-green top-menu-basket-link"
                    style={{
                      borderRadius: 15,
                      backgroundColor: "#1aab86 !important",
                    }}
                  >
                    ثبت و نهایی کردن سفارش
                    <i className="fa fa-chevron-left mr-half align-middle" />
                  </Link>
                </div>
              </>
            ) : (
              <div className="top-menu-basket-empty">
                سبد خرید شما خالی است.
              </div>
            )}
          </div>
        </div>
      </>
    );
};

export default DropdownBasketComponent;
